import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.scss";
import LocationMap from "./app/google-map";

export const AppContext = React.createContext<{ googleMapsApiKey: string; environment: string, partners: [], textStrings: {searchBarPlaceholder: string}, initialMapCenter: {lat: number, lng: number}, initialMapZoom: number, searchLocation: {lat: number, lng: number}, lang: string, region: string }>({
    environment: "",
    googleMapsApiKey: "",
    partners: [],
    textStrings: {searchBarPlaceholder: 'Stadt oder PLZ eingeben'},
    initialMapCenter: {lat: 47.484231, lng: 13.706869},
    searchLocation: {lat: 47.484231, lng: 13.706869},
    initialMapZoom: 8,
    lang: "en",
    region: "EN"
});

const rootElement = document.getElementById("partners-widget") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
const appData = JSON.parse(window.atob(rootElement.dataset.appData!));
root.render(
    <React.StrictMode>
        <AppContext.Provider value={appData}>
            <LocationMap/>
        </AppContext.Provider>
    </React.StrictMode>
);
